import { render } from "./ModalBlock.vue?vue&type=template&id=5c15a9e2&scoped=true"
import script from "./ModalBlock.vue?vue&type=script&lang=js"
export * from "./ModalBlock.vue?vue&type=script&lang=js"

import "./ModalBlock.vue?vue&type=style&index=0&id=5c15a9e2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c15a9e2"]])

export default __exports__